import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import "./ContexteFiscal.css";

const PensionRetraiteRente = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">🎯</span>
          Catégorie
        </div>
        <div className="value-column">
          <span className="header-icon">👤</span>
          Client
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Conjoint
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Pensions, retraites, rentes */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏦</div>
            Pensions, retraites, rentes
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRetraite"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRetraite")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointRetraite"]}
              onChange={context.handleInputChange(Outil + "IRConjointRetraite")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Pension d'invalidité */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏥</div>
            Pension d'invalidité
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantInvalidite"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantInvalidite")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointInvalidite"]}
              onChange={context.handleInputChange(Outil + "IRConjointInvalidite")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Pensions alimentaires perçues */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👨‍👩‍👧‍👦</div>
            Pensions alimentaires perçues
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAlimentaire"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAlimentaire")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointAlimentaire"]}
              onChange={context.handleInputChange(Outil + "IRConjointAlimentaire")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Pensions de retraite en capital */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">💎</div>
            Pensions de retraite en capital taxables à 7,5%
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantCapital"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantCapital")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointCapital"]}
              onChange={context.handleInputChange(Outil + "IRConjointCapital")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PensionRetraiteRente;
